import URLSearchParams from "@ungap/url-search-params";
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { Card, Container } from "react-bootstrap";
import QRCode from "react-qr-code";
import { useDispatch, useSelector } from "react-redux";
import { UserSessionAction } from "src/store";
import { v4 as uuidv4 } from "uuid";

export const Qrcode: React.FC = () => {
  const dispatch = useDispatch();
  const { tvLoginHeader, tvLoginTitle, tvLoginSubTitle, tvLoginDescription } =
    useSelector(
      (state: any) => state.ConfigState?.config?.appSetting?.language
    );

  const [result, setResult] = useState({
    device_code: "",
    user_code: "",
    verification_uri: "",
    verification_uri_complete: "",
    expires_in: 0,
    interval: 0,
  });

  const [localuuid, setLocaluuid] = useState("");

  useEffect(() => {
    const localuuid = localStorage.getItem("uuidv4");
    if (localuuid) {
      setLocaluuid(localuuid);
    } else {
      const newuuid = uuidv4();
      localStorage.setItem("uuidv4", newuuid);
      setLocaluuid(newuuid);
    }
  }, []);

  const getAuth = useCallback(() => {
    axios
      .post(`${process.env.REACT_APP_API_URL}ids/connect/deviceauthorization`, {
        client_id: "Anten-Web",
        client_secret: process.env.REACT_APP_CLIENT_SECRET,
        scope: "IdentityServerApi offline_access WebApi",
      })
      .then((res) => {
        setResult(res.data);
      });
  }, []);

  useEffect(() => {
    getAuth();
  }, [getAuth]);

  const checkLogin = async () => {
    const urlencoded = new URLSearchParams();
    urlencoded.append("client_id", "Anten-Web");
    urlencoded.append("client_secret", process.env.REACT_APP_CLIENT_SECRET!);
    urlencoded.append(
      "grant_type",
      "urn:ietf:params:oauth:grant-type:device_code"
    );
    urlencoded.append(
      "deviceInfo",
      `{\n"platform": 5,\n"model":"",\n"screenHeight": ${window.outerHeight},\n"screenWidth": ${window.outerWidth},\n"udid": "${localuuid}",\n"manufacturer": "Desktop"\n}\n`
    );
    urlencoded.append("device_code", result.device_code);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}ids/connect/token`,
        urlencoded
      );
      dispatch(UserSessionAction.login(res.data.user));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    let interval: NodeJS.Timeout;
    if (result.device_code && localuuid) {
      interval = setInterval(() => {
        checkLogin();
      }, result.interval * 1000);
      timeout = setTimeout(() => {
        // clearInterval(interval);
        getAuth();
      }, result.expires_in * 1000);
    }
    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localuuid, result]);

  return (
    <Container
      style={{
        display: "flex",
        height: "90%",
        justifyContent: "space-between",
        alignItems: "center",
        textAlign: "right",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <img
          src={tvLoginHeader}
          alt="helper"
          style={{ maxWidth: "100vw", height: "auto", marginBottom: "30px" }}
        />
        <div style={{ display: "flex", flexDirection: "row" }}>
          <QRCode
            style={{
              height: "300px",
              width: "300px",
              background: "white",
              padding: "16px",
              borderRadius: "10px",
              margin: "0 20px",
            }}
            value={`${process.env.REACT_APP_FRONT_URL}activate/${result.user_code}`}
            viewBox={`0 0 128 128`}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            {/* <p
              style={{
                color: "white",
                fontSize: "2.5rem",
                lineHeight: "1.5",
              }}
            >
              {tvLoginTitle || "ورود از طریق اسکن بارکد"}
            </p> */}
            {/* <p style={{ color: "#B8B8B8" }}>
              {tvLoginSubTitle ||
                "بارکد سمت راست صفحه را با دوربین موبایل خود اسکن کنید"}
            </p> */}

            <p style={{ color: "#B8B8B8" }}>
              {tvLoginDescription ||
                "یا می توانید آدرس زیر را در مرورگر موبایل، لپ تاپ یا تبلت خود وارد نمایید و از طریق لینک زیر وارد شوید:"}
            </p>

            <p
              style={{
                color: "white",
                fontSize: "2.5rem",
                fontFamily: "sans-serif",
              }}
            >
              {`${process.env.REACT_APP_FRONT_URL}activate/${result.user_code}`}
            </p>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Card
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-around",
                  alignItems: "center",
                  width: "60%",
                  padding: "10px",
                  whiteSpace: "nowrap",
                }}
              >
                <span style={{ color: "white" }}>کد اعتبارسنجی</span>
                <span
                  style={{
                    color: "white",
                    fontSize: "2rem",
                    backgroundColor: "#A3244C",
                    borderRadius: "15px",
                    padding: "1rem",
                    fontFamily: "sans-serif",
                  }}
                >
                  {result.user_code}
                </span>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};
